export default "/static/media/error.967cf90bdf740d827ffc1c98c07a3dcd.svg";